export var IntegrationName = /*#__PURE__*/ function(IntegrationName) {
    IntegrationName["Xero"] = "xero";
    IntegrationName["Qbo"] = "qbo";
    return IntegrationName;
}({});
export var SyncStatusState = /*#__PURE__*/ function(SyncStatusState) {
    SyncStatusState["InProgress"] = "inProgress";
    SyncStatusState["Completed"] = "completed";
    return SyncStatusState;
}({});
export var AccountingInvoiceSyncStatusEnum = /*#__PURE__*/ function(AccountingInvoiceSyncStatusEnum) {
    AccountingInvoiceSyncStatusEnum["InvoiceCreatedType"] = "invoiceCreated";
    AccountingInvoiceSyncStatusEnum["InvoiceFailureType"] = "invoiceFailure";
    AccountingInvoiceSyncStatusEnum["InvoicePaidType"] = "invoicePaid";
    AccountingInvoiceSyncStatusEnum["PaymentCreatedType"] = "paymentCreated";
    AccountingInvoiceSyncStatusEnum["PaymentFailureType"] = "paymentFailure";
    AccountingInvoiceSyncStatusEnum["ExpenseCreatedType"] = "expenseCreated";
    AccountingInvoiceSyncStatusEnum["ExpenseFailureType"] = "expenseFailure";
    AccountingInvoiceSyncStatusEnum["InvoiceVoidedType"] = "invoiceVoided";
    AccountingInvoiceSyncStatusEnum["RefundCreatedType"] = "refundCreated";
    AccountingInvoiceSyncStatusEnum["RefundFailureType"] = "refundFailure";
    AccountingInvoiceSyncStatusEnum["DisputeWonPaymentCreatedType"] = "disputeWonPaymentCreated";
    AccountingInvoiceSyncStatusEnum["DisputeWonPaymentFailureType"] = "disputeWonPaymentFailure";
    AccountingInvoiceSyncStatusEnum["DeletedType"] = "deleted";
    AccountingInvoiceSyncStatusEnum["PartiallyRefundCreatedType"] = "partiallyRefundCreated";
    AccountingInvoiceSyncStatusEnum["PartiallyRefundFailureType"] = "partiallyRefundFailure";
    return AccountingInvoiceSyncStatusEnum;
}({});
export var AccountingInvoiceSyncStatusFailureCodeEnum = /*#__PURE__*/ function(AccountingInvoiceSyncStatusFailureCodeEnum) {
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrUnknown"] = "unknown";
    //invoice
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrDuplicateDocNumber"] = "duplicate_document_number_error";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrAmountCalculationIncorrect"] = "amount_calculation_incorrect";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrCustomerDeleted"] = "customer_deleted";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrVendorDeleted"] = "vendor_deleted";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrClassDeleted"] = "class_deleted";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrItemDeleted"] = "item_deleted";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrAccountDeleted"] = "account_deleted";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrAccountPeriodClosed"] = "account_period_closed";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrInvalidCompanyStatus"] = "invalid_company_status";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrMissingPermissions"] = "missing_permissions";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrTimeActivityCannotAppliedToInvoice"] = "time_activity_transaction_cannot_be_applied_to_invoice";
    // xero unique errors
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrInvoiceCreationLockDate"] = "invoice_creation_lock_date";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrRateLimitExceeded"] = "rate_limit_exceeded";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrApprovedInvoicesLimit"] = "approved_invoices_limit";
    //payment
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrInvoiceAmountNotMatching"] = "invoice_amount_not_matching";
    AccountingInvoiceSyncStatusFailureCodeEnum["RefundAmountNotMatching"] = "refund_amount_not_matching";
    AccountingInvoiceSyncStatusFailureCodeEnum["PerLineRefundRejected"] = "per_line_refund_rejected";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrObjectNotFound"] = "object_not_found";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrInvoicePaid"] = "invoice_paid";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrInvoiceDeleted"] = "invoice_deleted";
    //deposit
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrPaymentDeleted"] = "payment_deleted";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrDepositTotalAmountNotMatching"] = "deposit_total_amount_not_matching";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrBusinessValidationTransactionCannotBeApplied"] = "transaction_cannot_be_applied_to_deposit";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrDepositBankAccountInvalid"] = "deposit_bank_account_invalid";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrCodeInvoiceClientNotMapped"] = "invoice_client_not_mapped";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrCodeInvoiceServiceNotMapped"] = "invoice_service_not_mapped";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrCodeInvoiceClientAndServiceNotMapped"] = "invoice_client_service_not_mapped";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrCodePayoutTransactionsNotSynced"] = "payout_transactions_not_synced";
    AccountingInvoiceSyncStatusFailureCodeEnum["ClassTrackingDisabledWithOverride"] = "class_tracking_disabled_with_override";
    AccountingInvoiceSyncStatusFailureCodeEnum["CustomErrItemIsCategory"] = "item_is_category";
    // inner errors
    AccountingInvoiceSyncStatusFailureCodeEnum["RequestTimeout"] = "REQUEST_TIMEOUT";
    return AccountingInvoiceSyncStatusFailureCodeEnum;
}({});
